import React from "react";
import { ResidentWifiKey } from "./ResidentWifiKey";
import { VisitorWifiKey } from "./VisitorWifiKey";
import { DeviceWifiKey } from "./DeviceWifiKey";
import { ByWifiKey } from "./ByWifiKey";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Tab } from "@mui/material";
import { VillageWifiDashboard } from "./VillageWifiDashboard";
import DashboardIcon from '@mui/icons-material/Dashboard';
import WifiTetheringIcon from '@mui/icons-material/WifiTethering';
import TabletAndroidIcon from '@mui/icons-material/TabletAndroid';
import BadgeIcon from '@mui/icons-material/Badge';
import PersonIcon from '@mui/icons-material/Person';
import { CheckHealth } from "../Maintenance/components/CheckHealth";


const tabSx = {

    fontSize: '16px',
    fontWeight: 'bold',
    textTransform: 'none',

};


export const VillageWifi: React.FC = ( ) => {

    const [ tab, setTab ] = React.useState< string >( '1' );
  

    const handleTabChange = ( _: React.SyntheticEvent, tab: string ) => setTab( tab );

    
    return(

        
        <>
        
            <CheckHealth />
            <TabContext value={ tab }>
                
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={ handleTabChange }>
                        <Tab icon={ <BadgeIcon /> } iconPosition="start"  label="BHP Employee/Contractor" value="1" sx={ tabSx } />
                        <Tab icon={ <PersonIcon /> } iconPosition="start" label="Visitor" value="2" sx={ tabSx } />
                        <Tab icon={ <TabletAndroidIcon /> } iconPosition="start" label="Device" value="3" sx={ tabSx } />
                        <Tab icon={ <WifiTetheringIcon /> } iconPosition="start" label="Search by Wi-Fi Key" value="4" sx={ tabSx } />
                        <Tab icon={ <DashboardIcon /> } iconPosition="start" label="Dashboard" value="5" sx={ tabSx } />
                    </TabList>
                </Box>

                <TabPanel value="1">
                    <ResidentWifiKey />
                </TabPanel>
                
                <TabPanel value="2">
                    <VisitorWifiKey />
                </TabPanel>
            
                <TabPanel value="3">
                    <DeviceWifiKey />
                </TabPanel>
                
                <TabPanel value="4">
                    <ByWifiKey />
                </TabPanel>

                <TabPanel value="5">
                    <VillageWifiDashboard />
                </TabPanel>

            </TabContext>

        </>

    );

};